import { Ref, RefCallback, RefObject } from 'react';

export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return (value: T | null) => {
    refs.forEach((ref) => {
      if (!ref) return;
      if (typeof ref === 'function') {
        ref(value);
      } else {
        try {
          (ref as RefObject<T | null>).current = value;
        } catch {}
      }
    });
  };
}
